import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FadeLoader } from 'react-spinners';
import {fetchMarcas, fetchFamiliaxUser, fetchModelos, fetchConfiguraciones, fetchSkuVehiculo, loadMantenimiento } from '../../actions';
import PageHeader from '../../components/PageHeader';
import Alert from '../../components/Alert';
import Filtros from './Filtros';
import TablaMantenimiento from './TablaMantenimiento';
import Formulario from './Formulario';
import toggleDiv from '../../utils/toggleDiv';
import SkuVehiculoDetalle from './SkuVehiculoDetalle';
import Paginacion from '../../components/Paginacion';
//<88181>
class MantSkuVehiculo extends Component {
	
  constructor(props) {
    super(props);
    this.state = {		
	// paginacion
       pagina: 1,
       totalRegistros: 0,
       cantidad: 0,
	//Otros
       familia:'',  
	   marca:'',   
	   modelo:'',
	   config:'', 
	//Filtros
	   familiaFilter:'',
	   marcaFilter:'',
	   skuFilter:'',	  
	  modalOpen: '',
      modalTitle: 'Crear registro',
      familiaFormulario: '',
	  marcaFormulario: '',
	//-----------------	  
	  listaSkuVehiculo: [],	  
	//-----------------
	  codigoModelo: '',
      nombreModelo: '',
	  codigoConfig:'',
	  nombreConfig:'',
	  listaFamilias: [],
	  listaMarcas: [],
	  listaModelos: [],
	  listaConfigur: [],
    };
	 sessionStorage.setItem('pestania',0);//Serviras para las pestañas
  }  
  
    componentDidMount() { 
    document.addEventListener('click', toggleDiv, true);   
	
    this.props.fetchFamiliaxUser() 
 		.then(({ payload: { data } }) => this.setState({ 
			 listaFamilias: data.busqueda }));
	  	  
	this.props.fetchModelos('', '') 
 		.then(({ payload: { data } }) => this.setState({ 
			 listaModelos: data.busqueda }));
			 
	/*this.props.fetchConfiguraciones('','')
		 .then(({ payload: { data } }) => this.setState({ 
		     listaConfigur: data.busqueda}));*/
			 
   }  
   
    componentWillUnmount() { 
    document.removeEventListener('click', toggleDiv, true);
  }	
  
    onChangeValue = e => this.setState({ [e.target.name]: e.target.value });
  			
	limpiarListaPrincipal(){
	this.setState({
	listaSkuVehiculo:[],
	 });
	}	
			
	limpiarFiltros(){
	this.setState({
    codigoConfig:'',
	codigoModelo:'',
	nombreConfig:'',
    nombreModelo:'',
	marcaFilter:'',
	totalRegistros:'',
	cantidad:'',
	 });
    }	
			
	onChangeAndShowMarcas = (e) => {
     this.limpiarFiltros();	
    this.setState(
      { [e.target.name]: e.target.value },
      () => {
        const { familiaFilter } = this.state;
		this.props.loadMantenimiento();
        this.props.fetchMarcas(familiaFilter)
		  .then(({ payload: { data } }) => this.setState({ 
			 listaMarcas: data.busqueda }));			 
      }
    );
  }  
  
   searchBuscar = (e) =>{
   	  	 this.limpiarListaPrincipal();
    const {  familiaFilter, marcaFilter, codigoModelo, codigoConfig, skuFilter, pagina} = this.state;
    this.props.loadMantenimiento();
    this.props.fetchSkuVehiculo(familiaFilter, marcaFilter, codigoModelo, codigoConfig,  skuFilter, pagina)
       .then(({ payload: { data } }) => this.setState({ 
	    listaSkuVehiculo: data.busqueda,
		totalRegistros: data.totalRegistros,
        cantidad: data.busqueda.length,
        pagina: 1  })); 
  }
  

 

    			
	onChangeAndShowModelos = (e) => {
   	 this.limpiarListaPrincipal();
	 this.limpiarFiltros();	
     this.setState(
      { [e.target.name]: e.target.value },
      () => {
        const { familiaFilter, marcaFilter } = this.state;
		this.props.loadMantenimiento();
		
        this.props.fetchModelos(familiaFilter, marcaFilter) 
 		.then(({ payload: { data } }) => this.setState({ 
			 listaModelos: data.busqueda }));
      }			 
    );
  }
  
    //#################SELECCIONAR MODELO ##################################  
    selectModeloxCod = (key) => {
	 this.limpiarListaPrincipal();
	const { marcaFilter, listaModelos } = this.state;				
    this.setState({
      codigoModelo: key ,    
	  nombreModelo:listaModelos.filter(({ codBaumuster }) => codBaumuster === key)[0].desBaumuster ,                 	  
    });	
	  this.props.loadMantenimiento();
	  this.props.fetchConfiguraciones(marcaFilter, key)
	 .then(({ payload: { data } }) => this.setState({ 
  	  listaConfigur: data.busqueda}));
  };  
  
    selectModeloxDes = (key) => {
	 this.limpiarListaPrincipal();
	const { marcaFilter, listaModelos } = this.state;				
    this.setState({
      codigoModelo: key,
	  nombreModelo: listaModelos.filter(({ codBaumuster }) => codBaumuster === key)[0].desBaumuster,    	  
    });	
	  this.props.loadMantenimiento();
	  this.props.fetchConfiguraciones(marcaFilter, key)
	 .then(({ payload: { data } }) => this.setState({ 
  	  listaConfigur: data.busqueda}));	
  };
  
    //#################SELECCIONAR CONFIGURACION ############################ 
    selectConfiguracionxDes = (key) => {
	 this.limpiarListaPrincipal();
	const { listaConfigur } = this.state;		
    this.setState({
      codigoConfig: key,
	  nombreConfig: listaConfigur.filter(({ codigo }) => codigo === key)[0].descripcion,                           
    });
  };
  
    selectConfiguracionxCod = (key) => {
	 this.limpiarListaPrincipal();
	const { listaConfigur } = this.state;		
    this.setState({
      codigoConfig: key,
	  nombreConfig: listaConfigur.filter(({ codigo }) => codigo === key)[0].descripcion,                           
    });
  };
    
 	
    filter = () => {
    const { familiaFilter, marcaFilter,  codigoModelo, codigoConfig,skuFilter, pagina} = this.state;
    this.props.loadMantenimiento();
    this.props.fetchSkuVehiculo( familiaFilter, marcaFilter,  codigoModelo, codigoConfig, skuFilter, pagina)
      .then(({ payload: { data } }) => this.setState({
	    listaSkuVehiculo: data.busqueda,
		totalRegistros: data.totalRegistros,
        cantidad: data.busqueda.length}));
  }
    
	backPag = () => {
		 this.limpiarListaPrincipal();
		if (this.state.pagina === 1) return;
		this.setState(
		  { pagina: this.state.pagina - 1 },
		  () => {
		   const { familiaFilter, marcaFilter,  codigoModelo, codigoConfig,skuFilter, pagina} = this.state;
		this.props.loadMantenimiento();
			this.props.fetchSkuVehiculo( familiaFilter, marcaFilter, codigoModelo, codigoConfig, skuFilter, pagina)
			  .then(({ payload: { data } }) => this.setState({ 
				listaSkuVehiculo: data.busqueda,
				totalRegistros: data.totalRegistros,
				cantidad: data.busqueda.length }));
		  }
		);
	  }

	nextPag = () => {
		 this.limpiarListaPrincipal();
		if (this.state.pagina * 10 > this.state.totalRegistros) return;
		this.setState(
		  { pagina: this.state.pagina + 1 },
		  () => {
			const { familiaFilter, marcaFilter, codigoModelo, codigoConfig, skuFilter, pagina} = this.state;
			this.props.loadMantenimiento();
			this.props.fetchSkuVehiculo( familiaFilter, marcaFilter, codigoModelo, codigoConfig, skuFilter, pagina)
			  .then(({ payload: { data } }) => this.setState({ 
				listaSkuVehiculo: data.busqueda,
				totalRegistros: data.totalRegistros,
				cantidad: data.busqueda.length }));
		  }
		);
	  }
    
    openModalWithValues = (modal, mantenimiento) => {
    this.setState({
      modalOpen: modal,
      familiaFormulario: mantenimiento.codigo || '',
      marcaFormulario: mantenimiento.codMarca || '',  
      disabledSelects: true,
      registroSelected: mantenimiento.skuSap,
      modalTitle: 'Editar registro',
    });
  }
  
    editRegistro = (registro) => {
    fetchFamiliaxUser('1')
      .then((response) => {
        if (response.data.estadoTrama === '1') {
          this.showAlert('alertSuccessOpen');         
        }
        this.resetForm();
      });
  }
    
    reset = () => {
	this.props.loadMantenimiento();
    this.setState({
      modalOpen: '',
      modalTitle: 'Crear registro',
      familiaFormulario: '',
      marcaFormulario: '',      
      disabledSelects: false,
      registroSelected: '',
	  familiaFilter:'',
	  marcaFilter:'',
	  skuFilter:'',
	  pagina: 1,	  
	  codigoModelo: '',
      nombreModelo: '',
	  codigoConfig:'',
	  nombreConfig:'',	  
	  listaMarcas:[],
    });	 
  }
  
    resetForm = () => {
	this.props.loadMantenimiento();
    this.setState({
      modalOpen: '',
      modalTitle: 'Crear registro',
      familiaFormulario: '',
      marcaFormulario: '',      
      disabledSelects: false,
      registroSelected: '',
    });
  }
  
    onChangetext = (e) => {
    this.setState(
      { [e.target.name]: e.target.value });
  }
   
  
  closeModal = () => this.setState({ modalOpen: '' });
  openModal = modal => this.setState({ modalOpen: modal });

    render() {
	const { familiaFilter,marcaFilter, codigoModelo, codigoConfig, skuFilter, listaSkuVehiculo,listaFamilias, listaMarcas,  listaModelos, listaConfigur } = this.state;	
    const { familias } = this.props;

    return (
      <div>
        <PageHeader title='Mantenimiento de Sku de Vehículos' />       	   
	  <div>
	  <Filtros
          familias={familias}
          familia={this.state.familia}
					  
   		  familiaFilter={this.state.familiaFilter}
		  marcaFilter={this.state.marcaFilter}	
		  skuFilter={this.state.skuFilter}	  
          listaFamilias={this.state.listaFamilias}
          listaMarcas={this.state.listaMarcas}
		  
		  codigoModelo={this.state.codigoModelo}
		  nombreModelo={this.state.nombreModelo}				  
		  selectModeloxDes={this.selectModeloxDes}
		  selectModeloxCod={this.selectModeloxCod}		  
          listaModelos={this.state.listaModelos}
		  
		  codigoConfig={this.state.codigoConfig}
		  nombreConfig={this.state.nombreConfig}
		  selectConfiguracionxDes={this.selectConfiguracionxDes}
		  selectConfiguracionxCod={this.selectConfiguracionxCod}
		  listaConfigur={this.state.listaConfigur}
		  
		  searchBuscar = {this.searchBuscar}
		  onChangetext = {this.onChangetext}			 
		  onChangeValue={this.onChangeValue}
		  onChangeAndShowMarcas={this.onChangeAndShowMarcas}
		  onChangeAndShowModelos={this.onChangeAndShowModelos}
		  filter={this.filter}
		  reset={this.reset}
		/>
		
	   <Paginacion
          paginas={this.state.totalRegistros}
          pagina={this.state.pagina}
          cantidad={this.state.cantidad}
          backPag={this.backPag}
          nextPag={this.nextPag}/>
	   </div>		
	   
        <div className='wrapper'>
          <div className='tableWrapper'>
            <table className='table table-hover' style={{ marginBottom: '20px' }} >
              <thead className='table-head'>
                <tr>
				  <th>EDITAR</th>              
                  <th>Familia</th>
                  <th>Marca</th>
                  <th>Modelo</th>
                  <th>Configuracion</th>
                  <th>Sku</th>
				  <th>Variante</th>
                  <th>Tipo vehiculo</th>
                  <th>Tipo SKU</th>				  
                  <th>Combustible</th>				  
                  <th>Reporte Euro</th>				 
                  <th />
                </tr>
              </thead>
              {
                listaSkuVehiculo ?
                  <TablaMantenimiento
                    skuvehiculos={listaSkuVehiculo}			
                  /> :
                  <tbody>
                    <tr>
                      <td colSpan={11}></td>
                    </tr>
                  </tbody>
              }
            </table>
          </div>
        </div>

	  
	  <Formulario
          isOpen={this.state.modalOpen === 'mantenimiento'}
          title={this.state.modalTitle}
          closeModal={this.resetForm}
          onChangeValue={this.onChangeValue}
          create={this.createRegistro}
          edit={this.editRegistro}
          familias={familias}
          familiaFormulario={this.state.familiaFormulario}
          marcaFormulario={this.state.marcaFormulario}
    
          disabled={this.state.disabledSelects}
          registroSelected={this.state.registroSelected}
        />		
	  </div>
    );
  }   

}
function mapStateToProps(state) {
  return {
	familias: state.familias,
  };
}

MantSkuVehiculo.defaultProps = {
  familias: [],
};

export default connect(
 mapStateToProps,
{loadMantenimiento,fetchMarcas,fetchFamiliaxUser,fetchModelos,fetchConfiguraciones,fetchSkuVehiculo}
)(MantSkuVehiculo);




// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/MantSkuVehiculo.js